import {
  Avatar,
  Container,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import saved from "../../assets/sound/saved.wav";
import trash from "../../assets/sound/trash.mp3";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { Delete, Save } from "@mui/icons-material";

const PettyForm = ({
  id,
  date,
  setDate,
  description,
  setDescription,
  amount,
  setAmount,
  setOpenPetty,
  operation,
  textButton,
}) => {
  const current = new Date();
  const day = `${current.getDate()}`;
  const month = `${current.getMonth() + 1}`;
  const year = `${current.getFullYear()}`;
  const m = month < 10 ? "0" + month : month;
  const d = day < 10 ? "0" + day : day;
  const date1 = year + "-" + m + "-" + d;
  console.log(date1);
  const updatePettyCash = async () => {
    const userDoc = doc(db, "pettyCash", id);

    const newFields = {
      date: date,
      amount: amount,
      description: description,
    };
    await updateDoc(userDoc, newFields);

    window.location.reload();
  };

  const handleOnSubmit = () => {
    operation === "new" ? createPettyCash() : updatePettyCash();
    new Audio(saved).play();
    setOpenPetty(false);
  };

  const createPettyCash = async () => {
    const regRef = collection(db, "pettyCash");
    await addDoc(regRef, {
      date: date,
      amount: amount,
      description: description,
    });
  };

  const handleOnDelete = async () => {
    const userDoc = doc(db, "pettyCash", id);
    deleteDoc(userDoc);
    new Audio(trash).play();
    // window.location.reload();
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={1} sm={12}>
        <Typography variant="h6" sx={{ color: "purple" }}>
          Petty Cash
        </Typography>
        <Avatar
          variant="soft"
          size="sm"
          sx={{ alignContent: "center", alignItems: "center" }}
          src={
            "https://thehustle.co/wp-content/uploads/2020/09/News-Brief_2020-09-07T004254.152Z.png"
          }
        />
        <Divider sx={{ padding: "15px" }} />
      </Grid>

      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              value={date}
              label="Date"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="Amount (+/-)"
              value={amount}
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setAmount(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={1} sm={12}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="Description"
              value={description}
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />
          </Grid>
          <Grid
            item
            xs={1}
            sm={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <IconButton
              onClick={handleOnSubmit}
              variant="outlined"
              color="primary"
            >
              <Save sx={{ width: 30, height: 30 }} />
            </IconButton>

            <IconButton
              onClick={handleOnDelete}
              variant="outlined"
              color="secondary"
            >
              <Delete sx={{ width: 30, height: 30 }} />
            </IconButton>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default PettyForm;
